import Layout from '@/layout/base/layoutSegfy'

// "Inteligência" é o item de menu que vem da auth (chave SEGFY_INTELIGENCIA, link
// /inteligencia). O destino é a página de passagem do SSO no app novo, que entrega o
// corretor autenticado no produto — ver components/inteligencia/abrir.vue.
export default [{
  path: '/inteligencia',
  component: Layout,
  children: [{
    path: '',
    name: 'inteligencia',
    component: () => import('@/components/inteligencia/abrir'),
    meta: {
      auth: true
    }
  }]
}]
